import * as tslib_1 from "tslib";
import { TextEvent } from "./TextEvent";
var ErrorEvent = (function (_super) {
    tslib_1.__extends(ErrorEvent, _super);
    function ErrorEvent(type, bubbles, cancelable, text, id) {
        if (bubbles === void 0) { bubbles = false; }
        if (cancelable === void 0) { cancelable = false; }
        if (text === void 0) { text = ""; }
        if (id === void 0) { id = 0; }
        return _super.call(this, type, bubbles, cancelable, text) || this;
    }
    Object.defineProperty(ErrorEvent.prototype, "errorID", {
        get: function () {
            console.log("errorID not implemented yet in flash/ErrorEvent");
            return 0;
        },
        enumerable: true,
        configurable: true
    });
    ErrorEvent.prototype.clone = function () {
        console.log("clone not implemented yet in flash/ErrorEvent");
        return null;
    };
    ErrorEvent.prototype.toString = function () {
        console.log("toString not implemented yet in flash/ErrorEvent");
        return "";
    };
    return ErrorEvent;
}(TextEvent));
export { ErrorEvent };
ErrorEvent.ERROR = "error";
